export interface IFsLprQueryParameters {
  cursor?: string;
  size?: number;
  [name: string]: any;
}
